__turbopack_context__.v({
  "button": "bento-one-module-scss-module__BhYO3q__button",
  "button-left": "bento-one-module-scss-module__BhYO3q__button-left",
  "button-right": "bento-one-module-scss-module__BhYO3q__button-right",
  "carousel": "bento-one-module-scss-module__BhYO3q__carousel",
  "chevron": "bento-one-module-scss-module__BhYO3q__chevron",
  "container": "bento-one-module-scss-module__BhYO3q__container",
  "flexContainer": "bento-one-module-scss-module__BhYO3q__flexContainer",
});
